module.exports = __webpack_public_path__ + "static/media/background.1380601f.svg";